/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Dropdown, useDropdownHelper, DefaultDropdownProps } from 'framework/form';
import { LEAD_DISQUALIFICATION_REASON } from 'domain/sales/lead/shared/leadService';

const DisqualificationReasonDropdown = (props: DefaultDropdownProps) => {
  const { getRawOnChangeCallback, getSource } = useDropdownHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});

  /*
     When DisqualificationReasonDropdown is not mounted - value should be null
  */
  useEffect(() => {
    return () =>
      rawOnChangeCallback({
        [getSource()]: null,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dropdown
      placeholder="Choose disqualification reason"
      options={Object.entries(LEAD_DISQUALIFICATION_REASON).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label="Disqualification reason"
      {...props}
    />
  );
};

export default DisqualificationReasonDropdown;
